import React, {useState, useEffect} from 'react'
//! Styles
import './cfodpm.css'
//! SweetAlert
import Swal from 'sweetalert2'
//! Axios
import axios from 'axios'
import moment from 'moment-timezone'
// Actions
import { Base_API } from '../../_actions/matcher'
// Components
import Copyright from '../../components/Copyright'
import { NhealthAction } from '../../_actions/action.api'
import { useParams } from 'react-router-dom'
import { DecryptedOBJ, DecryptedText, EncryptedText } from '../../utils/Encryption'


function CFOD_Payment(props) {
    const { ref, type } = useParams();

    const [errorMsg, setErrorMsg] = useState('');
    const [errorStatus, setErrorStatus] = useState(false);
    const [statementPreview, setStatementPreview] = useState('');
    const [packOrder, setPackOrder] = useState([]);
    const [totalPriceOrder, setTotalPriceOrder] = useState('');
    const [uploadStatus, setUploadStatus] = useState(false);
    const [percent, setPercent] = useState(0);
    const [orderQuantity, setOrderQuantity] = useState(0);
    const [campaignData, setCampaignData] = useState(null);
    const [memberData, setMemberData] = useState(null);
    const [lineUserID, setLineUserID] = useState(null);
    const [memberCode, setMemberCode] = useState(null);
    const [loading, setLoading] = useState(true);
    const [slipLoader, setSlipLoader] = useState(false);
    const [closeSubmit, setCloseSubmit] = useState(false);
    // form api
    const [fileName, setFileName] = useState("");

    // check & clear
    useEffect(() => {
        dataInit();
    },[])

    const dataInit = async() => {
        let campaignData = await campaignInit();
        let user = await checkUserInit();
        await checkReCreateCart(campaignData, user);
        handleConfirmOrder();
        handlerLoader('inactive');
    }

    const checkReCreateCart = (campaignData, memberData) => {
        return new Promise(async resolve => {
            let cameFromRegistration = localStorage.getItem('cameFromRegistration'); // เช็คก่อนว่ามาจาก หน้าสมัครสมาชิกไหม ถ้าใช่แสดงว่าสินค้าอยู่ในตระกร้าก่อนที่จะสมัคร ต้องทำการ clear แล้ว add item to cart ใหม่ครับ
            if(!!cameFromRegistration)
            {
                let cartList = await calCartInit(campaignData, memberData.line_id);  // ดึง cart จาก line user เอามาใส่ใน member แทน
                await clearCart(cartList); // clear old ของ line user
                await createCart(campaignData, memberData.membercode, cartList); // เพื่มใหม่ที่ nhealth member
                resolve();
            }else
            {
                resolve();
            }
        })
    }

    const clearCart = (cartList) => {
        return new Promise(async resolve => {
            for(var i in cartList)
            {
                let item = cartList[i];

                NhealthAction.DeleteCart(item.cartid)
                .then(res => {
                    
                })

                if(Number(i) === cartList.length-1)
                {
                    resolve();
                }
            }
        })
    }

    const createCart = (campaignData, membercode, cartList) => {
        return new Promise(async resolve => {
            for(var i in cartList)
            {
                let item = cartList[i];

                let reqData = {
                    campaign: campaignData.id,
                    _refcampaign: ref,
                    membercode: membercode,
                    SKU: item.itemSKU,
                    itemSKU: item.itemSKU,
                    totalAmount: item.totalAmount
                }
                // console.log('Req Data: ', reqData);
                NhealthAction.AddCart(reqData) 
                .then(res => {
                    // if(res.isSuccess === true)    
                    // {

                    // }
                });
                if(Number(i) === cartList.length-1)
                {
                    resolve();
                }
            }
        })
    }

    const calCartInit = (campaignData, membercode) => {
        return new Promise(async resolve => {
            let couponSelected = !!localStorage.getItem('couponselected') ? DecryptedOBJ(localStorage.getItem('couponselected')) : null;
            let useCoupon = !!couponSelected ? couponSelected.id : 0;

            NhealthAction.CalCart(campaignData.id, useCoupon, membercode)
            .then(res => {
                if(res.isSuccess === true)
                {
                    let cartList = res.cart;

                    resolve(cartList);
                }
            })
        })
    }

    const checkUserInit = () => {
        return new Promise(async resolve => {
            let line_profile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            if(line_profile !== null)
            {
                setLineUserID(line_profile.user_id);

                NhealthAction.GetMember(line_profile.user_id)
                .then(res => {
                    if(res.isSuccess === true)
                    {
                        setMemberData(res.member);
                        setMemberCode(res.member.membercode)

                        resolve({membercode: res.member.membercode, line_id: line_profile.user_id});
                    }else
                    {
                        setMemberCode(line_profile.user_id)
                        resolve({membercode: null, line_id: line_profile.user_id});
                    }
                })
            }else
            {
                window.location.href = `${Base_API.pathWeb}/n-health/packages/${ref}` // login again and again and againnnn !!!
            }
        })
    }

    const handlerLoader = (status) => {
        if(status === 'inactive')
        {
            setLoading(false);
        }else
        {
            setLoading(true);
        }
    };

    const campaignInit = () => {
        return new Promise(async resolve => {
            if(type === 'packages') 
            {
                NhealthAction.GetCampaign(ref).then(data => {
                    setCampaignData(data.campaign);
                    resolve(data.campaign);
                })
            }else
            {
                NhealthAction.GetCampaignProductsOnline(ref).then(data => {
                    setCampaignData(data.campaign);
                    resolve(data.campaign);
                })
            }
        })
    }

    const ReqDataInit = () => {
        return new Promise(async resolve => {
            let contactInformData = !!localStorage.getItem('cfod-contact-inform') ? DecryptedOBJ(localStorage.getItem('cfod-contact-inform')) : null;
            let line_profile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            let couponSelected = !!localStorage.getItem('couponselected') ? DecryptedOBJ(localStorage.getItem('couponselected')) : null;

            // console.log(contactInformData);
            // console.log(line_profile);

            let reqData = {
                "campaign": campaignData.id,
                "coupon": !!couponSelected ? couponSelected.id : 0,
                "membercode": memberCode,
                "tranchannel":"LINE OA",
                "Firstname": contactInformData[0].value,
                "Lastname": contactInformData[1].value,
                "Birthday": contactInformData[2].value,
                "Phoneno": contactInformData[3].value,
                "Email": contactInformData[4].value,
                "filename_refUpload": fileName,
                "refPaychannel":"bank_transfer",
                "receive_service_code": "",
                "receive_service": "",
                "line_display": line_profile.display_name,
                "line_profile": line_profile.picture_url,
                "line_user": line_profile.user_id,
                "line_token": line_profile.id_token,
                "isnonlab" : false,
                "istax" : false,
                "isAppoint" : false,
                "_postcode": "",
                "tax":{
                    "taxType":"",
                    "taxCompany":"",
                    "taxId":"",
                    "taxName":"",
                    "taxEmail":"",
                    "taxPhone":"",
                    "taxAddress":""
                },
                "appoint":[
                    {
                        "packages_code":"",
                        "appointmentDate": "", 
                        "receive_service_code":"",
                        "receive_service":"",
                        "remark":""
                    }
                ]
            }
            resolve(reqData);
        })
    }

    const showAlert = (msg) => {
        Swal.fire({
            title: "ผิดพลาด",
            text: msg,
            icon: 'error',
            confirmButtonText: 'ตกลง',
            customClass: {
                actions: 'my-actions',
                cancelButton: 'order-1 right-gap',
                confirmButton: 'order-2',
                denyButton: 'order-3',
            }        
        })
    }

    const handleConfirmOrder = () => {
        let netPrice = !!localStorage.getItem('netprice') ? DecryptedText(localStorage.getItem('netprice')) : null;
        setTotalPriceOrder(netPrice);
    }
    const onBack = () => {
        // window.location.href = `${Base_API.pathWeb}/n-health/confirm-order/${ref}`;
        window.history.back();
    }
    const onSubmit = async() => {
        if(uploadStatus) 
        {
            let reqData = await ReqDataInit();
            // console.log('Req Data: ', reqData);

            setCloseSubmit(true); // ปิด ไม่ให้กด create order

            NhealthAction.CreateOrder(reqData)
            .then(async res => {
                if(res.isSuccess === true)
                {
                    // clear
                    localStorage.removeItem('couponselected'); 
                    localStorage.removeItem('cameFromRegistration'); 
                    // set
                    localStorage.setItem('tran_no', EncryptedText(res.dataMessage));
                    // navigation
                    window.location.href = `${Base_API.pathWeb}/n-health/confirm-order/payment/success/${ref}`;
                }
                // console.log('Create Order: ', res);
            })
        }else
        {
            showAlert('กรุณาชำระเงินและอัปโหลดสลิป.');
        }
    }

    function GetLineProfile() {
        let lineProfile = localStorage.getItem('line_profile');
        var accessToken;
        if(!!lineProfile && lineProfile !== null && lineProfile !== "" && lineProfile !== undefined)
        {
            accessToken = DecryptedOBJ(localStorage.getItem('line_profile')).access_token;
            return accessToken;
        }
        return accessToken;
    }

    const onUploadFile = (file) => {
        // loading (true)
        setSlipLoader(true);

        if(!!file)
        {
            let fileSize = file.size;
            if(fileSize < 4000000)
            {
                // for preivew
                let fileType = String(file.type).split("/")[1];
                let urlPreview = URL.createObjectURL(file);
                //console.log(urlPreview) 
                if(fileType === 'jpg' || fileType === 'jpeg' || fileType === 'png')
                {
                    setStatementPreview(urlPreview);
                    // upload to api
                    let formData = new FormData();
                    formData.append('input type file', file);
            
                    setUploadStatus(true)
            
                    //! Send To Backend (Slip Payment)
                    axios.post(Base_API.api_upload_payment, formData, {headers: {access_token: GetLineProfile()}})
                    // axios.post('https://weblabonline.nhealth-asia.com/backoffice-lineoa/Transections/_upload_ref_transfers', formData)
                    // axios.post('https://onlineshop.nhealth-asia.com/backoffice/Transections/_upload_ref_transfers', formData)
                    .then(res => {
                        // console.log(res);
                        if(res.data.isSuccess === true)
                        {
                            setFileName(res.data.dataMessage);
                            setUploadStatus(true)
                            setSlipLoader(false);
                            setCloseSubmit(false); // reset ให้สามารถกลับมากดได้
                            // console.log(res.data)
                        }
                        else
                        {
                            console.error("Error API: upload Statement(Slip)")
                            setUploadStatus(false)
                            setSlipLoader(false);    
                        }
                    })
                    .catch(err => {
                        // console.log(err)
                    })
                }else
                {
                    setSlipLoader(false);    
                    showAlert('กรุณาอัปโหลดไฟล์ png, jpg, jpeg.');
                }
            }else
            {
                setSlipLoader(false);    
                showAlert('รูปต้องมีขนาดไม่เกิน 4 mb');
            }
        }else
        {
            setSlipLoader(false);    
        }
    }

    if(loading)
    {
        return (
            <div className="sls-loader-container">
                <div className="sls-loader"></div>
            </div>
        )
    }else
    {
        return (
            <div className="cfodpm_container">
                <div className="cfodpm-form_wrapper">
                    {/* header */}
                    <h1 className="cfodpm-form_header">แจ้งชำระเงิน</h1>
                    {/* title */}
                    <h2 className="cfodpm-form_title">บัญชีธนาคาร</h2>
    
                    {/* paymeny item */}
                    <div className="cfodpm-paymeny-itemwrap">
                        <div className="cfodpm-paymeny-item space">
                            <span className="cfodpm-paymeny-itemleft">บัญชีธนาคาร</span>
                            <span className="cfodpm-paymeny-itemright">ธนาคารไทยพาณิชย์</span>
                        </div>
                        <div className="cfodpm-paymeny-item">
                            <span className="cfodpm-paymeny-itemleft">ชื่อบัญชี</span>
                            <span className="cfodpm-paymeny-itemright">N HEALTH</span>
                        </div>
                        <div className="cfodpm-paymeny-item">
                            <span className="cfodpm-paymeny-itemleft">เลขบัญชี</span>
                            <a href='tel:043-2-77501-9' className="cfodpm-paymeny-itemright">043-2-77501-9 <a className='cfodpm-textclipboard' href='tel:043-2-77501-9'>COPY</a></a>
                        </div>
                        <div className="cfodpm-paymeny-item">
                            <span className="cfodpm-paymeny-itemleft">จำนวนเงินที่ต้องชำระ</span>
                            <span className="cfodpm-paymeny-itemright">{totalPriceOrder} บาท</span>
                        </div>
                    </div>
    
                    {/* button upload statement */}
                    <div className="cfodpm-paymeny-upload_wrapper">
                        <input onChange={(e) => onUploadFile(e.target.files[0])} type="file" id="cfodpm-paymeny-statement-upload" name="statement-file" />
                        <label htmlFor="cfodpm-paymeny-statement-upload"><i className="bi bi-paperclip"></i> อัพโหลดสลิป</label>
                    </div>
    
                    {/* statement preview */}
                    <div className="cfodpm-statement_preview">
                        <img src={statementPreview} alt="statement preview" style={statementPreview.length > 0 ? {opacity: 1} : {opacity: 0}} /> 
                    </div>
    
                    {/* button */}
                    <div className="cfodpm-button_wrapper">
                        <button 
                            className="cfodpm-btn_back"
                            onClick={onBack}
                        >
                            ย้อนกลับ
                        </button>
                        <button 
                            className="cfodpm-btn_submit"
                            onClick={closeSubmit ? null : onSubmit}
                        >
                            ชำระเงิน
                        </button>
                    </div>
                </div>
                {/* Copyright */}
                <Copyright position={'relative'} />

                {/* Overlay */}
                <div className={`ovl ${slipLoader === true ? "active" : "inactive"}`}>
                    <div className="sls-loader"></div>
                </div>
            </div>
        )
    }
}

export default CFOD_Payment